/**
 * 📚 TIER 5 BUILDINGS - Knowledge & Culture
 * 
 * Unlocked by: Writing, Literacy, Arts, Education, etc.
 * Cost multiplier: 39x | Prod multiplier: 6.55x
 * Costs: 2,000-4,000 | Production: 2.5-4/s
 * Target ROI: ~5 minutes
 */

export const TIER_05_BUILDINGS = {
  library: {
    id: 'library',
    name: 'Library',
    icon: '📚',
    tier: 5,
    description: 'Preserves knowledge in books',
    flavor: 'Knowledge is the greatest treasure.',
    baseCost: { wood: 2000, stone: 1600, gold: 800 },
    baseProduction: { knowledge: 1.3 },
    unlockCondition: { tech: 'writing' },
  },

  scriptorium: {
    id: 'scriptorium',
    name: 'Scriptorium',
    icon: '📖',
    tier: 5,
    description: 'Copies manuscripts',
    flavor: 'Every word preserved is wisdom saved.',
    baseCost: { wood: 2600, stone: 2000, gold: 1200 },
    baseProduction: { knowledge: 2.0, culture: 0.65 },
    unlockCondition: { tech: 'literacy' },
  },

  theater: {
    id: 'theater',
    name: 'Theater',
    icon: '🎭',
    tier: 5,
    description: 'Performances inspire culture',
    flavor: 'All the world is a stage.',
    baseCost: { wood: 3000, stone: 2400, gold: 1600 },
    baseProduction: { culture: 2.6 },
    unlockCondition: { tech: 'arts' },
  },

  academy: {
    id: 'academy',
    name: 'Academy',
    icon: '🏛️',
    tier: 5,
    description: 'Teaches advanced subjects',
    flavor: 'Where great minds gather.',
    baseCost: { stone: 3600, gold: 2000, iron: 1000 },
    baseProduction: { knowledge: 3.3 },
    unlockCondition: { tech: 'education' },
  },

  university: {
    id: 'university',
    name: 'University',
    icon: '🎓',
    tier: 5,
    description: 'Center of higher learning',
    flavor: 'The pursuit of truth knows no bounds.',
    baseCost: { stone: 5000, gold: 3600, iron: 1600 },
    baseProduction: { knowledge: 4.0, science: 0.65 },
    unlockCondition: { tech: 'higher_education' },
  },

  museum: {
    id: 'museum',
    name: 'Museum',
    icon: '🏺',
    tier: 5,
    description: 'Displays cultural treasures',
    flavor: 'Preserving the past, inspiring the future.',
    baseCost: { stone: 4000, gold: 2400, gems: 400 },
    baseProduction: { culture: 3.9 },
    unlockCondition: { tech: 'archaeology' },
  },
};

export default TIER_05_BUILDINGS;
